export default "__VITE_ASSET__e98c4cd4__"